'use client';

import type { MultistepFormProgressBarProps } from '../types';

/**
 * A progress bar component that shows the current step progress in a multistep form.
 * The progress is calculated as a percentage of completed steps, starting from the second step.
 */
function MultistepFormProgressBar({ currentStep, totalSteps }: MultistepFormProgressBarProps) {
  // Dont show the progress bar on the first step
  if (currentStep === 0) return null;

  // Calculate progress based on steps after the first one
  // Subtract 1 from totalSteps to exclude the first step
  const progress = (currentStep / (totalSteps - 1)) * 100;

  return (
    <div className="w-full h-1 md:h-2 bg-container dark:bg-foreground overflow-hidden" data-testid="progress-bar">
      <div className="h-full bg-accent-green transition-all duration-300 ease-in-out border border-accent-green rounded-sm" style={{ width: `${progress}%` }} />
    </div>
  );
}

export { MultistepFormProgressBar };
